import React from 'react';

import { Video, FlexContainer, Title, Image } from '../common/StyledComponents';

import companyVideo from '../../assets/companyVideo.mkv';
import backgroundImg from '../../assets/coffee.jpg';
import memberImg from '../../assets/kapil-pic.jpg';

const backgroundUrl = `url(${backgroundImg})`;

const members = [
  { img: memberImg, name: 'Kapil Jindal', pos: 'Co-Founder' },
  { img: memberImg, name: 'Devinder Maheshwari', pos: 'Co-Founder' },
  { img: memberImg, name: 'Rupesh Sinha', pos: 'Staff Writer' },
  { img: memberImg, name: 'Akshar Gangwar', pos: 'Staff Writer' },
  { img: memberImg, name: 'Nikhil Subramaniam', pos: 'Staff Writer' },
  { img: memberImg, name: 'Anmol Sachdeva', pos: 'Staff Writer' },
  { img: memberImg, name: 'Kishalaya Kundu', pos: 'Staff Writer' },
  { img: memberImg, name: 'Karthik Iyer', pos: 'Staff Writer' },
  { img: memberImg, name: 'Nadeem Sarwar', pos: 'Staff Writer' },
  { img: memberImg, name: 'Mandeep Mishra', pos: 'Finance Manager' },
  { img: memberImg, name: 'Manmeet Singh', pos: 'Video Team' },
  { img: memberImg, name: 'Sharun Mittal', pos: 'Video Team' },
  { img: memberImg, name: 'Nawaz Shek', pos: 'Video Team' },
  { img: memberImg, name: 'Karan Sumadhari', pos: 'Video Team' },
  { img: memberImg, name: 'Tushar Mehta', pos: 'Staff Writer' },
  { img: memberImg, name: 'Pranob Mehrotra', pos: 'Staff Writer' },
  { img: memberImg, name: 'Rachit Agarawal', pos: 'Staff Writer' },
  { img: memberImg, name: 'Arti Singh', pos: 'Human Resource Team' },
  { img: memberImg, name: 'Nitin Rustagi', pos: 'SEO Consultant' },
  { img: memberImg, name: 'Durgesh Kukreti', pos: 'UI/UX Designer' },
  {
    img: memberImg,
    name: 'Sushant Kumar',
    pos: 'Senior Android/NodeJS Developer'
  },
  { img: memberImg, name: 'Deepak Rathi', pos: 'Android Developer' },
  { img: memberImg, name: 'Ashish Sharma', pos: 'Backend Web Developer' },
  { img: memberImg, name: 'Kapil Sharma', pos: 'Frontend Web Developer' }
];

const About = () => {
  window.scrollTo(0, 0);

  const memberImages = members.map((member, index) => {
    return (
      <FlexContainer
        className="flex-column items-center pv3 pv4-ns ph2 ph3-ns"
        key={`${index}`}
      >
        <Image
          className="mb3 mb4-ns"
          src={member.img}
          alt={index}
          width="168px"
          height="168px"
          borderradius="50%"
        />
        <Title
          className="mb2 mb3-ns"
          fontFamily="Nunito"
          fontWeight="bold"
          fontSize="1.2rem"
          color="#fff"
        >
          {member.name}
        </Title>
        <Title
          className="mb1 mb2-ns"
          fontFamily="Nunito"
          fontSize="1rem"
          color="#fff"
        >
          {member.pos}
        </Title>
      </FlexContainer>
    );
  });
  return (
    <div className="w-100">
      <FlexContainer
        className="background-video bg-center cover"
        background="#222"
      >
        <Video loop autoPlay muted>
          <source src={companyVideo} type="video/mp4" />
          {/* <source src={companyVideo} type="video/ogg" /> */}
          {/* Your browser does not support the video tag. */}
        </Video>
      </FlexContainer>
      <FlexContainer
        background="#222"
        className="vh-50 justify-center items-center"
        // className="h5-ns justify-center items-center"
      >
        <FlexContainer maxwidth="950px">
          <Title
            // className="pa3 pa4-m pa5-l"
            className="ph3 ph4-ns pv4 pv5-ns"
            fontFamily="Montserrat"
            fontSize="1.5rem"
            fontstyle="italic"
            lineHeight="1.5"
            color="#ffffff"
          >
            Beebom is one of the leading consumer technology websites aimed at
            helping people understand and use technology in a better way.
          </Title>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer
        className="vh-75 vh-50-ns justify-center items-center bg-center cover"
        background={backgroundUrl}
      >
        <FlexContainer maxwidth="950px">
          <Title
            // className="pa3 pa4-m pa5-l"
            className="pa3 pa4-ns"
            fontFamily="Montserrat"
            fontWeight="bold"
            lineHeight="1.3"
            fontSize="2.6rem"
            color="#4db2ec"
          >
            WE ARE ON A MISSION TO TOUCH EVERY TECH CONSUMER’S LIFE BY HELPING
            THEM DO MORE WITH THEIR DEVICES.
          </Title>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer background="#222" justifycontent="center">
        <FlexContainer maxwidth="950px" direction="column">
          <Title
            className="ph3 ph4-ns pb3 pb4-ns pt4 pt5-ns tc"
            fontFamily="Nunito"
            fontWeight="bold"
            fontSize="4.25rem"
            color="#fff"
          >
            Our Story
          </Title>
          <Title
            className="ph3 ph4-ns pb4 pb5-ns tj"
            fontFamily="Nunito"
            fontSize="1.5rem"
            lineHeight="2.38rem"
            color="#fff"
          >
            Founded in 2011 (then called thetecnica) as an effort, turned into a
            passion and later into a responsibility to help people use
            technology in the most efficient way possible. If you want to read
            our story of how we scaled ourselves from nothing to a leading (and
            responsible) technology website, read our coverage on YourStory.
            <br />
            <br />
            As per current stats, Beebom is catering to more than 20 million
            monthly users combined at all our platforms and growing rapidly. Our
            audience consists of end consumers of technology, geeks, early
            adopters and influencers.
          </Title>
          <Title
            className="ph3 ph4-ns pt3 pt5-ns pb4 pb5-ns tc"
            fontFamily="Montserrat"
            fontWeight="900"
            fontSize="4.5rem"
            letterSpacing="12px"
            color="transparent"
            backgroundClip="text"
            backgroundImage="linear-gradient(96deg, #7117ea, #ea6060)"
          >
            WE ARE BEEBOM
          </Title>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer justifycontent="center" background="#222">
        <FlexContainer
          className="flex-wrap justify-around pb5 pb6-ns"
          maxwidth="950px"
        >
          {memberImages}
        </FlexContainer>
      </FlexContainer>
      {/* <FlexContainer
        className="w-100"
        style={{ height: '5px', background: '#4db2ec' }}
      /> */}
    </div>
  );
};

export default About;
